export const environment = {
  production: true,
  apiBaseUrl: 'https://api-codebaseone.azurewebsites.net',
  defaultLang: 'en-US',
  supportedLangs: ['en-US', 'fa-IR', 'tr-TR','de-DE'],
  appInsightConnectionString: "InstrumentationKey=7a3ecabe-1b5e-4fea-9c7f-722542658f16;IngestionEndpoint=https://switzerlandwest-0.in.applicationinsights.azure.com/;LiveEndpoint=https://switzerlandwest.livediagnostics.monitor.azure.com/;ApplicationId=cb89161c-3dff-4a0c-8cfa-ebfcec67d211"
};
